export enum RoleType {
  general_user = 'general_user',
  staff = 'staff',
  leader = 'leader',
  admin = 'admin',
}

export interface UserViewModel extends UserInfo {
  id: string
  name: string
  email: string
  phone: string
  // role: Role
}

export interface UserInfo {
  name: string
  phone: string
  role: Role
}

export interface Role {
  type: RoleType
  regions_accessed: string[]
}
